import { createRouter, createWebHistory } from "vue-router";
import { sources } from "@/reusable";
import MainLayout from "@/components/Layouts/MainLayout.vue";
import VehicleDetails from "@/views/VehicleDetails.vue";
import MarketPlace from "@/views/MarketPlace.vue";
import FaqsView from "@/views/FaqsView.vue";
import AboutUs from "@/views/AboutUs.vue";
const routes = [
  {
    path: "/",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "FutureRent",
        component: () => import("../views/FutureRent.vue"),
      },
      {
        path: "/apply-now",
        name: "Apply Now",
        component: () => import("../views/LeadsForm.vue"),
        beforeEnter: async (to, from, next) => {
          const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
            const [name, value] = cookie.split("=");
            acc[name] = decodeURIComponent(value);
            return acc;
          }, {});

          try {
            if (to.query.source) {
              if (cookies.source) {
                to.meta.source = cookies.source;
                document.cookie = `source=${encodeURIComponent(
                  cookies.source
                )}; path=/; Secure; SameSite=Strict`;
              } else {
                if (sources.includes(to.query.source)) {
                  to.meta.source = to.query.source;
                  document.cookie = `source=${encodeURIComponent(
                    to.query.source
                  )}; path=/; Secure; SameSite=Strict`;
                } else {
                  return next({ name: "NotFound" });
                }
              }
            }
            if (to.query.campaign) {
              // Check if 'campaign' cookie exists
              if (cookies.campaign) {
                to.meta.campaign = cookies.campaign;
                document.cookie = `campaign=${encodeURIComponent(
                  cookies.campaign
                )}; path=/; Secure; SameSite=Strict`;
              } else {
                to.meta.campaign = to.query.campaign;
                document.cookie = `campaign=${encodeURIComponent(
                  to.query.campaign
                )}; path=/; Secure; SameSite=Strict`;
              }
            }
            if (to.query.referrer) {
              if (cookies.referrer) {
                to.meta.referrer = cookies.referrer;
                document.cookie = `referrer=${encodeURIComponent(
                  cookies.referrer
                )}; path=/; Secure; SameSite=Strict`;
              } else {
                to.meta.referrer = to.query.referrer;
                document.cookie = `referrer=${encodeURIComponent(
                  to.query.referrer
                )}; path=/; Secure; SameSite=Strict`;
              }

              // to.meta.referrer = { campaign: to.query.referrer};
              // document.cookie = `referrer=${encodeURIComponent(to.query.referrer)}; path=/; Secure; SameSite=Strict`;
            }
            next();
          } catch (error) {
            console.error("Failed to fetch leads:", error);
            next(false); // Cancel navigation or redirect
          }
        },
      },
      {
        path: "/Ts&Cs",
        name: "Terms & Conditions",
        component: () => import("../views/Legal/TCsView.vue"), // adjust path
      },
      {
        path: "/win-a-car/Ts&Cs",
        name: '"Win a Car" Competition Terms and Conditions',
        component: () => import("../views/Legal/CompetitionTCs.vue"), // adjust path
      },
    ],
  },
  {
    path: "/market-place",
    name: "Market Place",
    component: MarketPlace, // adjust path
  },
  {
    path: "/faqs",
    name: "FAQS",
    component: FaqsView, // adjust path
  },
  {
    path: "/about-us",
    name: "About Us",
    component: AboutUs, // adjust path
  },
  {
    path: "/vehicle/:carname",
    name: "VehicleDetails",
    component: VehicleDetails,
    props: (route) => ({
      carname: route.params.carname,
      id: route.meta.vehicleId, // access the id from meta
    }),
  },
  {
    path: "/compare",
    name: "CompareView",
    component: () => import("../views/CompareView.vue"),
  },
  // {
  //   path: "/competitions",
  //   name: "Competitions",
  //   component: () => import("../views/Competitions/CompetitionView.vue"), // adjust path
  // },
  // {
  //   path: "/win-a-car/Ts&Cs",
  //   name: '"Win a Car" Competition Terms and Conditions',
  //   component: () => import("../views/Legal/CompetitionTCs.vue"), // adjust path
  // },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("../views/ErrorView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    }
    return { top: 0 };
  },
  routes,
});

export default router;
